import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import { getStyles } from '../styles';

const AIAssistantButton = ({ onClick, isActive, disabled }) => {
    const theme = useTheme();
    const styles = getStyles(theme);

    return (
        <Tooltip title="AI Assistant">
            <IconButton
                onClick={onClick}
                disabled={disabled}
                sx={{
                    ...styles.aiAssistantBtn,
                    ...(isActive ? styles.aiAssistantBtnActive : {}),
                }}
            >
                <Icon icon="mdi:sparkles" width={18} height={18} />
            </IconButton>
        </Tooltip>
    );
};

AIAssistantButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    disabled: PropTypes.bool,
};

AIAssistantButton.defaultProps = {
    isActive: false,
    disabled: false,
};

export default AIAssistantButton;
